import type { ReactNode } from 'react';

export type LeafletMapWithPopupsProps = {
  mapContent?: ReactNode;
  popupContent?: ReactNode;
};

export function LeafletMapWithPopups({ mapContent, popupContent }: LeafletMapWithPopupsProps) {
  return (
    <div className="border border-1 border-dark w-100 h-100 position-relative">
      {mapContent}

      <div className="popup-wrapper position-absolute top-0 start-0 m-2 z-3">{popupContent}</div>
    </div>
  );
}
